import { Box, Stack, Typography, styled } from "@mui/material"
import { BarTrack, Row, Share, Title, TitleSuffix } from "./components"
import type { RxSplitDisplay } from "./salesRxSplit.type"
import { getUniverseDisplay } from "./utils"

export const NoRxUniversesSplitBar = ({ noRx }: RxSplitDisplay) => (
  <Stack>
    <NoRxUniversesTitle />

    <Stack gap={1}>
      <Row gap={1}>
        {noRx.universes.map((universe) => (
          <UniverseBar key={universe.name} {...universe} />
        ))}
      </Row>

      <Row gap={1} justifyContent="space-between">
        {noRx.universes.map((universe) => (
          <UniverseLegend key={universe.name} {...universe} />
        ))}
      </Row>
    </Stack>
  </Stack>
)

const NoRxUniversesTitle = () => (
  <Row gap={0.5}>
    <Title>repartition</Title>
    <TitleSuffix>hors rx</TitleSuffix>
  </Row>
)

type NoRxUniverseDisplay = RxSplitDisplay["noRx"]["universes"][number]

const minWidth = 4
const UniverseBar = ({
  name,
  value,
  totalPercent,
  percent,
}: NoRxUniverseDisplay) => {
  if (!value) return null

  return (
    <Stack
      width={`${percent}%`}
      minWidth={`${minWidth}ch`}
      sx={{ alignItems: "end" }}
    >
      <Share value={totalPercent} variant="small" />
      <BarTrack sx={{ backgroundColor: getUniverseDisplay(name).color }} />
    </Stack>
  )
}

const UniverseLegend = ({ name, value }: NoRxUniverseDisplay) => {
  const { color, shortLabel } = getUniverseDisplay(name)

  if (!value) return null

  return (
    <Row gap={0.5} alignItems="center">
      <Dot bgcolor={color} />
      <Typography variant="12px">{shortLabel}</Typography>
    </Row>
  )
}

const Dot = styled(Box)({
  padding: 8,
  borderRadius: 100,
})
